import React, { ChangeEvent, FC } from "react";
import { FormControl, TextField } from "@mui/material";

interface CustomFormInputProps {
  title?: string;
  placeholder?: string;
  onChange: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  type?: "text" | "textarea";
  value: string;
  customClass?: string;
  customContainer?: string;
  name: string;
  disabled?: boolean;
}

const CustomFormInput: FC<CustomFormInputProps> = ({
  title = "",
  placeholder = "",
  onChange,
  type = "text",
  value = "",
  customClass = "",
  name,
  disabled,
  customContainer = "",
}) => {
  return (
    <div className={`customFormInput w-full lg:w-[48%] ${customContainer}`}>
      <h3 className="font-semibold text-xl text-bgSidebar leading-10">
        {title}
      </h3>

      {type === "textarea" ? (
        <textarea
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
          placeholder={placeholder}
          className={`w-full bg-white shadow-lg my-5 border-0 outline-none px-4 py-3 ${customClass}`}
        />
      ) : (
        <FormControl
          fullWidth
          disabled={disabled}
          className="!border-none !outline-none !my-5"
        >
          <TextField
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                border: 0,
              },
              "& .MuiOutlinedInput-root": {
                backgroundColor: "#fff",
                // boxShadow:
                //   "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
                borderRadius: 0,
              },
            }}
            className={`bg-white shadow-lg !rounded-none !border-none !outline-none ${customClass}`}
          />
        </FormControl>
      )}
    </div>
  );
};

export default CustomFormInput;
